/*************************************************************************
 *
 * 建物・契約切替機能
 *
 *************************************************************************/
$(function() {
  /*
   * 建物名編集ダイアログ
   */
  const building_name_editor = (function() {
    const element = $("#building-name-editor");

    function open(oid, building_name) {
      element.find("[name=oid]").val(oid);
      element.find("[name='building_name']").val(building_name);
      element.show();
    }

    function close() {
      element.hide();
    }

    element.remove().appendTo($("body"));

    /*
     * 「キャンセル」ボタン
     */
    element.find(".cancel").click(function() {
      close();
    });

    /*
     * 周辺の押下でメニューを閉じます。
     */
    element.click(function(event) {
      if ($(event.target).is("#building-name-editor")) {
	close();
      }
    });
    
    return {
      open: open,
      close: close
    };
  })();
  
  /*
   * 建物・契約切替メニュー
   */
  const menu = (function() {
    const element = $("#switch-owner-menu");

    function close() {
      element.fadeOut();
    }

    element.remove().appendTo($("body"));

    /*
     * 「x」ボタン
     */
    element.find(".close-menu").click(function(event) {
      event.preventDefault();
      close();
    });

    /*
     * 周辺の押下でメニューを閉じます。
     */
    element.click(function(event) {
      if ($(event.target).is("#switch-owner-menu")) {
	close();
      }
    });

    /*
     * 建物名の編集
     */
    element.find(".edit-building-name").click(function(event) {
      event.preventDefault();
      building_name_editor.open($(this).data("oid"), $(this).data("building-name"));
    });

    return {
      visible: function() {
	return element.is(":visible");
      },
      open: function() {
	element.fadeIn();
      },
      open_at: function(top, left) {
	element.find("> .body").css({top: top, left: left});
	this.open();
      },
      close: close
    };
  })();

  $(".switch-owner-button").click(function() {
    const self = $(this);
    if (menu.visible()) {
      menu.close();
    } else {
      /*
       * 「建物・契約切替」ボタンの下に表示します。
       */
      const pos = (function() {
	if ($("#is-pc").is(":visible")) {
	  const pos = self.offset();
	  return {
	    top: pos.top + 24 + 5,
	    left: pos.left
	  };
	} else {
	  return { top: "", left: "" };
	}
      })()
      menu.open_at(pos.top, pos.left);
    }
  });
});



// WEBPACK FOOTER //
// ./src/js/moc_switch_owner.js